var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutCryptoIllus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 27,
    viewBox: "0 0 77 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13 24C18.5228 24 23 19.5228 23 14C23 8.47715 18.5228 4 13 4C7.47715 4 3 8.47715 3 14C3 19.5228 7.47715 24 13 24Z",
    fill: "#224DDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7L19.0622 10.5V17.5L13 21L6.93782 17.5V10.5L13 7Z",
    stroke: "#224DDA",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.701 16.4192C35.3652 21.7763 29.9384 25.0363 24.5799 23.7007C19.224 22.3651 15.9633 16.9389 17.2994 11.582C18.6346 6.22424 24.0611 2.96363 29.418 4.29925C34.7761 5.63487 38.0365 11.0617 36.7007 16.4192H36.701Z",
    fill: "#F7931A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9153 12.4897C31.0905 11.3162 30.1971 10.6854 28.9754 10.2646L29.3717 8.67493L28.4038 8.43379L28.0179 9.98152C27.7638 9.91814 27.5026 9.85833 27.243 9.79908L27.6316 8.24114L26.6645 8L26.2679 9.58908C26.0574 9.54112 25.8507 9.49372 25.65 9.44384L25.6511 9.43888L24.3167 9.10568L24.0593 10.1392C24.0593 10.1392 24.7772 10.3037 24.7621 10.3139C25.154 10.4117 25.2251 10.6711 25.2129 10.8767L24.7615 12.6876C24.7885 12.6945 24.8235 12.7044 24.8621 12.7198L24.7601 12.6945L24.1271 15.2313C24.0792 15.3504 23.9576 15.529 23.6837 15.4612C23.6933 15.4752 22.9804 15.2856 22.9804 15.2856L22.5 16.3935L23.7595 16.7074C23.9016 16.743 24.0421 16.7797 24.181 16.8159C24.271 16.8394 24.3603 16.8627 24.449 16.8854L24.0486 18.4935L25.0151 18.7347L25.4119 17.1439C25.6757 17.2156 25.932 17.2817 26.1828 17.344L25.7876 18.9273L26.7552 19.1685L27.1556 17.5637C28.8056 17.8759 30.0466 17.75 30.5683 16.2579C30.9891 15.0563 30.5476 14.3632 29.6795 13.9109C30.3117 13.7646 30.7879 13.3487 30.915 12.4897H30.9153ZM28.7042 15.5899C28.4295 16.6927 26.7029 16.2364 25.9136 16.0278C25.8429 16.0091 25.7798 15.9924 25.7258 15.979L26.2572 13.8489C26.3231 13.8654 26.4036 13.8835 26.4948 13.9039L26.4949 13.9039C27.3114 14.0872 28.9848 14.4627 28.7045 15.5899H28.7042ZM26.659 12.9155C27.3176 13.0912 28.7531 13.4742 29.0032 12.4723C29.2589 11.4474 27.8629 11.1385 27.1812 10.9876C27.1046 10.9707 27.0369 10.9557 26.9817 10.942L26.5 12.8739C26.5456 12.8852 26.5991 12.8995 26.659 12.9155Z",
    fill: "#F7931A"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 13.9999C49 19.5228 44.5229 24 39.0001 24C33.4772 24 29 19.5228 29 13.9999C29 8.47712 33.4772 4 39.0001 4C44.5228 4 49 8.47712 49 13.9999",
    fill: "#505050"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9568 7L38.8769 7.27148V15.1493L38.9568 15.229L42.6136 13.0675L38.9568 7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9568 7L35.3 13.0675L38.9568 15.229V11.4054V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9568 16.4188L38.9118 16.4736V19.2799L38.9568 19.4113L42.6158 14.2583L38.9568 16.4188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9568 19.4114V16.4188L35.3 14.2583L38.9568 19.4114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9568 15.229L42.6135 13.0675L38.9568 11.4054V15.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3 13.0675L38.9567 15.229V11.4054L35.3 13.0675Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13.9999C63 19.5228 58.5229 24 53.0001 24C47.4772 24 43 19.5228 43 13.9999C43 8.47712 47.4772 4 53.0001 4C58.5228 4 63 8.47712 63 13.9999",
    fill: "#00A478"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6721 13.7738V11.5115H48.6037V9.5285H57.1779V11.5394H54.1096V13.7738H51.6721Z",
    fill: "#00A478"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2846 14.0252C47.2846 13.2711 49.7507 12.6566 52.8191 12.6566C55.8875 12.6566 58.3537 13.2711 58.3537 14.0252C58.3537 14.7793 55.8875 15.3937 52.8191 15.3937C49.7507 15.3937 47.2846 14.7793 47.2846 14.0252ZM57.8949 14.0252C57.6941 13.7459 56.0309 12.8801 52.8191 12.8801C49.6074 12.8801 47.9441 13.7179 47.7434 14.0252C47.9441 14.3045 49.6074 14.7234 52.8191 14.7234C56.0596 14.7234 57.6941 14.3045 57.8949 14.0252Z",
    fill: "#00A478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1096 14.4721V12.908C53.7081 12.8801 53.2779 12.8521 52.8478 12.8521C52.4463 12.8521 52.0735 12.8521 51.7007 12.8801V14.4441C52.0448 14.4441 52.4463 14.4721 52.8478 14.4721C53.2779 14.5 53.7081 14.5 54.1096 14.4721Z",
    fill: "#00A478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8191 15.3938C52.4176 15.3938 52.0449 15.3938 51.6721 15.3658V19.5273H54.0809V15.3379C53.6794 15.3658 53.2493 15.3938 52.8191 15.3938Z",
    fill: "#00A478"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74 13.9999C74 19.5228 69.5229 24 64.0001 24C58.4772 24 54 19.5228 54 13.9999C54 8.47712 58.4772 4 64.0001 4C69.5228 4 74 8.47712 74 13.9999",
    fill: "#3CC8C8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8683 7.59863C65.042 7.2687 64.6429 6.86923 64.316 7.04143C64.05 7.14847 63.9825 7.53734 64.1895 7.73408C64.3849 7.93908 64.7674 7.86757 64.8683 7.59863ZM61.2294 7.74416C61.2496 7.52552 60.9982 7.34173 60.7996 7.42431C60.5232 7.4987 60.4925 7.93847 60.7607 8.0434C60.9631 8.1562 61.2504 7.98151 61.2294 7.74416ZM68.0016 8.05007C67.6912 8.01219 67.6421 7.51931 67.9409 7.42007C68.1726 7.3059 68.3853 7.51999 68.4192 7.74188C68.3706 7.93135 68.2135 8.10484 68.0016 8.05007ZM62.3544 9.42939C62.4055 9.03984 61.9317 8.72393 61.5997 8.93605C61.2888 9.09666 61.246 9.57582 61.5282 9.78469C61.82 10.0506 62.3372 9.82272 62.3544 9.42939ZM66.6683 9.16113C66.8164 8.77552 67.4166 8.76385 67.5852 9.13923C67.7519 9.43135 67.5469 9.7931 67.25 9.89242C66.8567 9.96658 66.4831 9.53711 66.6683 9.16113ZM64.5 9.26954C64.1882 9.29211 63.8893 9.53908 63.8925 9.87052C63.8748 10.1414 64.0663 10.3626 64.2938 10.4754C64.3167 10.4768 64.3399 10.4786 64.3632 10.4805C64.4917 10.4908 64.6252 10.5015 64.7408 10.4361C65.0396 10.3026 65.1864 9.90211 65.0211 9.61128C64.9323 9.40045 64.7069 9.31143 64.5 9.26954ZM58.6631 10.3535C58.9664 10.1651 59.3756 10.5089 59.2608 10.8417C59.1976 11.1295 58.8145 11.2467 58.5955 11.0629C58.3617 10.8907 58.3988 10.4767 58.6631 10.3535ZM70.5439 10.7107C70.5745 10.3826 70.1499 10.1511 69.8926 10.3529C69.6285 10.5167 69.6572 10.9539 69.9385 11.0816C70.194 11.2357 70.5611 11.01 70.5439 10.7107ZM65.3631 10.9487C65.7878 10.7946 66.2922 10.979 66.5342 11.3614C66.8535 11.8289 66.6836 12.5409 66.1881 12.8092C65.6748 13.1264 64.9251 12.8575 64.7355 12.2784C64.5203 11.76 64.8339 11.1112 65.3631 10.9487ZM64.203 11.4498C63.9756 10.9636 63.3423 10.7753 62.8716 10.9997C62.37 11.226 62.1393 11.8935 62.3991 12.3849C62.6309 12.8931 63.3065 13.1014 63.7854 12.8267C64.2636 12.5823 64.4705 11.9232 64.203 11.4498ZM60.3769 11.8612C60.4127 11.5549 60.6987 11.3556 60.9873 11.335C61.2983 11.3729 61.5467 11.6168 61.5805 11.9347C61.5601 12.2494 61.3194 12.557 60.9892 12.5551C60.626 12.5867 60.3075 12.2217 60.3769 11.8612ZM68.6197 11.9342C68.6362 11.5015 68.1184 11.1823 67.7455 11.4016C67.3452 11.5923 67.3151 12.2229 67.7008 12.4469C68.0721 12.7158 68.6452 12.3927 68.6197 11.9342ZM61.8577 13.0175C62.2938 12.8963 62.7925 13.1039 63.0064 13.5089C63.2407 13.9164 63.1449 14.4826 62.781 14.7816C62.3143 15.2201 61.4535 15.044 61.2051 14.4456C60.9197 13.897 61.2664 13.1619 61.8577 13.0175ZM67.7334 13.4479C67.5054 13.0578 67.0074 12.8927 66.5834 13.0152C65.9877 13.18 65.6722 13.9435 65.9857 14.4837C66.2443 15.006 66.9723 15.1814 67.4422 14.8473C67.8909 14.5597 68.0347 13.8942 67.7334 13.4479ZM59.0526 13.5243C59.4293 13.3804 59.8469 13.8003 59.6943 14.1776C59.6011 14.5213 59.1215 14.6483 58.8738 14.3949C58.5839 14.157 58.6913 13.6275 59.0526 13.5243ZM69.8015 13.4598C69.4814 13.4773 69.253 13.7565 69.2639 14.0718C69.3265 14.2189 69.4024 14.3723 69.5506 14.4484C69.8666 14.6245 70.3136 14.3698 70.29 13.9951C70.3104 13.7114 70.0595 13.5011 69.8015 13.4598ZM57.2003 13.7094C57.4269 13.6095 57.7073 13.8079 57.6555 14.0621C57.6434 14.35 57.2226 14.4607 57.068 14.2201C56.9315 14.0531 57.0132 13.7955 57.2003 13.7094ZM71.9699 13.8597C71.9067 13.6714 71.6506 13.5889 71.491 13.7036C71.2255 13.8467 71.3296 14.342 71.6513 14.3124C71.8805 14.3472 72.0772 14.0654 71.9699 13.8597ZM63.0888 15.0855C63.6852 14.9289 64.3263 15.4312 64.33 16.0515C64.3689 16.6783 63.7375 17.2342 63.127 17.0894C62.6551 17.0126 62.2848 16.5535 62.3001 16.0718C62.2989 15.6111 62.643 15.183 63.0888 15.0855ZM66.7066 16.0593C66.7162 15.4247 66.056 14.9133 65.4507 15.0842C65.0918 15.1743 64.7879 15.4731 64.7086 15.8405C64.5516 16.3919 64.9666 17.0161 65.5291 17.0896C66.1269 17.2117 66.7386 16.6745 66.7066 16.0593ZM60.8967 15.4661C61.3156 15.3939 61.7083 15.8659 61.5384 16.2676C61.4145 16.6958 60.7977 16.8119 60.525 16.4622C60.2051 16.1264 60.444 15.5124 60.8967 15.4661ZM68.6266 16.0627C68.6554 15.6533 68.1969 15.3269 67.8234 15.4849C67.3719 15.6298 67.2966 16.325 67.7103 16.5612C68.0756 16.8243 68.6416 16.5135 68.6266 16.0627ZM69.7594 17.4464C69.6132 17.1711 69.8788 16.8061 70.1815 16.857C70.3239 16.8546 70.4258 16.9615 70.5179 17.0581L70.534 17.075L70.5375 17.1029C70.5571 17.2599 70.5795 17.44 70.453 17.5586C70.2709 17.7914 69.8584 17.725 69.7594 17.4464ZM59.2883 17.3613C59.3519 17.0272 58.9448 16.7435 58.6619 16.9337C58.3924 17.0724 58.3828 17.5058 58.6433 17.658C58.886 17.8256 59.2544 17.6567 59.2883 17.3613ZM64.2509 17.5522C64.6212 17.3871 65.0931 17.7128 65.058 18.1248C65.0854 18.5801 64.5018 18.8955 64.1397 18.622C63.7375 18.3873 63.8046 17.6966 64.2509 17.5522ZM62.3723 18.6407C62.401 18.2841 61.9777 17.9945 61.6623 18.1622C61.44 18.2461 61.3494 18.4937 61.3455 18.7161C61.4215 18.9201 61.576 19.1346 61.8129 19.1398C62.099 19.183 62.3819 18.9335 62.3723 18.6407ZM66.9058 18.1673C67.2302 17.9648 67.6912 18.2557 67.6605 18.637C67.6689 19.0356 67.1478 19.2909 66.8458 19.0291C66.5534 18.8239 66.5891 18.3305 66.9058 18.1673ZM68.0775 19.9079C67.8432 19.9582 67.6734 20.2239 67.8177 20.4444C67.9658 20.7005 68.3981 20.6089 68.4256 20.3103C68.4652 20.0897 68.266 19.9466 68.0775 19.9079ZM60.5793 20.2529C60.6368 20.0781 60.776 19.9044 60.9797 19.9498C61.2766 19.9711 61.3647 20.4232 61.1049 20.5625C60.8712 20.7217 60.6 20.5037 60.5793 20.2529ZM64.678 20.2064C64.4596 20.0691 64.1283 20.1948 64.0714 20.4534C63.9675 20.7146 64.217 21.0304 64.4935 20.9977C64.6423 21.0015 64.7572 20.8945 64.8466 20.7874C64.864 20.7152 64.8817 20.643 64.9015 20.5708L64.9003 20.5662C64.8635 20.4285 64.8207 20.2683 64.678 20.2064Z",
    fill: "#3CC8C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 1.43782,
    y: 1.26794,
    width: 23.1244,
    height: 25.4641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 18.5,
    y: 5,
    width: 16.4373,
    height: 19.1685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 31.3,
    y: 4,
    width: 15.3158,
    height: 20.4113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 44.2846,
    y: 5.5285,
    width: 19.0691,
    height: 17.9988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_0_1",
    x: 56,
    y: 6,
    width: 17,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutCryptoIllus);
export default __webpack_public_path__ + "static/media/aboutCryptoIllus.b2ffbb50e0ace3670bd4584ab5ac764d.svg";
export { ForwardRef as ReactComponent };